import React, { useRef } from 'react';
import './RadioControl.scss';
import { getUid } from '../helpers/ids';

export default function RadioControl(props: Props) {
	const id = useRef<string>(`radio-control__${getUid()}`);
	
	return (
		<div className="radio-control__container">
			<div className="radio-control__radio" tabIndex={0} onClick={props.onSelected} onKeyPress={onKeyPress} role="radio" aria-checked={props.selected} aria-labelledby={id.current}>
				{props.selected && <div className="radio-control__radio-dot"></div>}
			</div>
			<span onClick={props.onSelected} id={id.current}>{props.label}</span>
		</div>
	);
	
	function onKeyPress(e: React.KeyboardEvent) {
		if (e.key === 'Enter' || e.key === ' ') {
			props.onSelected();
			e.preventDefault();
		}
	}
}

interface Props {
	label: string;
    selected: boolean;
    onSelected: () => void;
}
